export const key = (fst: string, scd: string) => `${fst}-${scd}`;
